import Component from 'flarum/common/Component';
export default class ComposerPreview extends Component {
  view() {
    return m("div", null);
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    s9e.TextFormatter.preview(vnode.attrs.content || '', vnode.dom);
  }
}
flarum.reg.add('v17development-blog', 'forum/components/Composer/ComposerPreview', ComposerPreview);